import React from 'react';
import '../styles/BookingSummaryModal.css';

const BookingSummaryModal = ({
  isOpen,
  onClose,
  car,
  bookingAmount,
  onConfirmBooking,
  loading
}) => {
  if (!isOpen || !car) return null;

  const carPrice = Number(car.price); 
  const bookingAmountValue = Number(bookingAmount);
  const remainingAmount = carPrice - bookingAmountValue;

  const reservationHours = bookingAmountValue >= 15000 ? 72 : 48;

  return (
    <div className="booking-modal-overlay" onClick={onClose}>
      <div
        className="booking-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="booking-modal-header">
          <h2>Confirm Your Booking</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="booking-modal-content">

          {/* Car Preview */}
          <div className="car-preview">
            <div className="car-preview-image">
              <img
                src={`http://localhost:3001${car.images_urls?.[0] || '/placeholder.jpg'}`}
                alt={car.title}
              />
            </div>

            <div className="car-preview-info">
              <h3 className="car-preview-title">{car.title}</h3>

              <div className="car-preview-specs">
                <span className="spec-item">📅 {car.year}</span>
                <span className="spec-item">⛽ {car.fuel_type}</span>
                <span className="spec-item">⚙️ {car.transmission}</span>
              </div>

              <div className="car-preview-details">
                <span className="detail-item">🛣️ {car.km_driven || car.mileage} km</span>
                <span className="detail-item">👤 {car.owner_count} Owner</span>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="booking-section">
            <div className="section-heading">📍 Location Details</div>
            <div className="location-item">
              <span className="location-label">City</span>
              <span className="location-value">{car.location}</span>
            </div>
            <div className="location-item">
              <span className="location-label">Delivery Type</span>
              <span className="location-value">Pickup from Hub</span>
            </div>
          </div>

          {/* Pricing */}
          <div className="booking-section pricing-breakdown">
            <div className="section-heading">💰 Pricing Details</div>

            <div className="price-row">
              <span className="price-label">Car Price</span>
              <span className="price-value">
                ₹{carPrice.toLocaleString('en-IN')}
              </span>
            </div>

            <div className="price-row booking-amount-row">
              <span className="price-label">
                Booking Amount
                <span className="refundable-badge">Refundable</span>
              </span>
              <span className="price-value booking-amount">
                ₹{bookingAmountValue.toLocaleString('en-IN')}
              </span>
            </div>

            {/* ✅ NEW: Remaining Amount */}
            <div className="price-row remaining-amount-row">
              <span className="price-label">Remaining Amount (Pay Later)</span>
              <span className="price-value remaining-amount">
                ₹{remainingAmount.toLocaleString('en-IN')}
              </span>
            </div>

            <div className="pricing-note">
              ℹ️ Booking amount will be adjusted in the final car price.
            </div>
          </div>

          {/* Terms */}
          <div className="booking-section">
            <div className="section-heading">📋 Booking Terms</div>
            <ul className="refund-list">
              <li>⏱️ Car reserved for <strong>{reservationHours} hours</strong></li>
              <li>💵 100% refundable if cancelled within 24 hours</li>
              <li>🚗 Test drive after booking confirmation</li>
            </ul>
          </div>

          {/* Notice */}
          <div className="notice-box">
            ⚠️ This is a booking payment only. Remaining amount will be collected
            after inspection & documentation.
          </div>
        </div>

        {/* Footer */}
        <div className="booking-modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>

          <button
            className="btn-confirm"
            onClick={onConfirmBooking}
            disabled={loading}
          >
            {loading ? 'Processing...' : `Pay ₹${bookingAmountValue.toLocaleString('en-IN')} & Book`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingSummaryModal;
